// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as RnrISE from "./RnrISE.bs.js";
import * as Caml_obj from "../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as GAEvents from "../../../../library/ga/GAEvents.bs.js";
import * as Caml_array from "../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as RnrLoading from "./RnrLoading.bs.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ReactModal from "react-modal";
import * as RewardCategory from "../../domain/types/RewardCategory.bs.js";
import * as RnrAssetManager from "../../assets/RnrAssetManager.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

var customerServiceLogo = RnrAssetManager.getImage("customer_experience_icon.svg");

var loginHoursLogo = RnrAssetManager.getImage("login_activity_icon.svg");

var orderFulfillmentLogo = RnrAssetManager.getImage("order_fulfillment_icon.svg");

function getRewardVM(rewards, date, category) {
  var date$1 = date !== undefined ? Caml_option.valFromOption(date) : ErrorUtils$Catalyst.raiseError("RnrClaimedRewardModal.re", "Invalid date", "");
  var reward = List.find((function (rewardVm) {
          if (Caml_obj.caml_equal(rewardVm.date, date$1)) {
            return true;
          } else {
            return false;
          }
        }), rewards);
  return List.find((function (rewardDetails) {
                return rewardDetails.name === category;
              }), reward.rewards);
}

function getLoginActivityRewardMessage(message, content) {
  var result = message.match(/(?:Login Hours )(\d*)/);
  return Curry._1(content.getLoginActivtyRewardsText, result !== null ? Caml_array.get(result === null ? undefined : Caml_option.some(result), 1) : "0");
}

function getOrderFulfillmentRewardMessage(message, content) {
  var result = message.match(/(?:You Completed )(\d*)(?: out of )(\d*)(?: orders )/);
  var result$1 = result === null ? undefined : Caml_option.some(result);
  var param = result !== null ? [
      Caml_array.get(result$1, 1),
      Caml_array.get(result$1, 2)
    ] : [
      "0",
      "0"
    ];
  return Curry._2(content.getOrderFulfillmentRewardsText, param[0], param[1]);
}

function getCustomerServiceRewardMessage(message, content) {
  var result = message.match(/(?:Five Star Trips )(\d*)(?: of )(\d*)/);
  var result$1 = result === null ? undefined : Caml_option.some(result);
  var param = result !== null ? [
      Caml_array.get(result$1, 1),
      Caml_array.get(result$1, 2)
    ] : [
      "0",
      "0"
    ];
  return Curry._1(content.getCustomerServiceRewardsText, param[0]);
}

function getCustomerServiceSuccessView(rewardDetails, content) {
  return React.createElement("div", {
              className: "reward-success-component__display"
            }, React.createElement("div", {
                  className: "reward-success-component__img-box reward-success-component__green-icon"
                }, React.createElement("img", {
                      className: "reward-success-component__img",
                      src: customerServiceLogo
                    })), React.createElement("div", {
                  className: "reward-success-component__points-display"
                }, React.createElement("div", {
                      className: "reward-success-component__won-title"
                    }, content.customerServiceRewards.text1), React.createElement("div", {
                      className: "reward-success-component__won-points"
                    }, String(rewardDetails.totalPoints) + (" " + content.miscellaneous.points)), React.createElement("div", {
                      className: "reward-success-component__category"
                    }, content.customerServiceRewards.text2)), React.createElement("div", {
                  className: "reward-success-component__detail"
                }, React.createElement("div", {
                      className: "reward-success-component__circle"
                    }), React.createElement("div", undefined, getCustomerServiceRewardMessage(rewardDetails.message, content)), React.createElement("div", {
                      className: "reward-success-component__circle"
                    })));
}

function getLoginActivitySuccessView(rewardDetails, content) {
  return React.createElement("div", {
              className: "reward-success-component__display"
            }, React.createElement("div", {
                  className: "reward-success-component__img-box reward-success-component__red-icon"
                }, React.createElement("img", {
                      className: "reward-success-component__img",
                      src: loginHoursLogo
                    })), React.createElement("div", {
                  className: "reward-success-component__points-display"
                }, React.createElement("div", {
                      className: "reward-success-component__won-title"
                    }, content.loginActivtyRewards.text1), React.createElement("div", {
                      className: "reward-success-component__won-points"
                    }, String(rewardDetails.totalPoints) + (" " + content.miscellaneous.points)), React.createElement("div", {
                      className: "reward-success-component__category"
                    }, content.loginActivtyRewards.text2)), React.createElement("div", {
                  className: "reward-success-component__detail"
                }, React.createElement("div", {
                      className: "reward-success-component__circle"
                    }), React.createElement("div", undefined, getLoginActivityRewardMessage(rewardDetails.message, content)), React.createElement("div", {
                      className: "reward-success-component__circle"
                    })));
}

function getOrderFulfillmentSuccessView(rewardDetails, content) {
  return React.createElement("div", {
              className: "reward-success-component__display"
            }, React.createElement("div", {
                  className: "reward-success-component__img-box reward-success-component__violet-icon"
                }, React.createElement("img", {
                      className: "reward-success-component__img",
                      src: orderFulfillmentLogo
                    })), React.createElement("div", {
                  className: "reward-success-component__points-display"
                }, React.createElement("div", {
                      className: "reward-success-component__won-title"
                    }, content.orderFulfillmentRewards.text1), React.createElement("div", {
                      className: "reward-success-component__won-points"
                    }, String(rewardDetails.totalPoints) + (" " + content.miscellaneous.points)), React.createElement("div", {
                      className: "reward-success-component__category"
                    }, content.orderFulfillmentRewards.text2)), React.createElement("div", {
                  className: "reward-success-component__detail"
                }, React.createElement("div", {
                      className: "reward-success-component__circle"
                    }), React.createElement("div", undefined, getOrderFulfillmentRewardMessage(rewardDetails.message, content)), React.createElement("div", {
                      className: "reward-success-component__circle"
                    })));
}

function getSuccessView(rewards, date, category, content, onRewardToggle) {
  var category$1 = category !== undefined ? category : ErrorUtils$Catalyst.raiseError("RnrClaimedRewardModal.re", "category type is not defined", "");
  var rewardDetails = getRewardVM(rewards, date, category$1);
  var tmp;
  switch (category$1) {
    case /* CustomerService */0 :
        tmp = getCustomerServiceSuccessView(rewardDetails, content);
        break;
    case /* LoginActivity */1 :
        tmp = getLoginActivitySuccessView(rewardDetails, content);
        break;
    case /* OrderFulfillment */2 :
        tmp = getOrderFulfillmentSuccessView(rewardDetails, content);
        break;
    
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "reward-success-component__close-button",
                  onClick: (function (_event) {
                      return Curry._2(onRewardToggle, undefined, undefined);
                    })
                }, "X"), tmp);
}

function getLoadingView(content) {
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "reward-success-component__close-button reward-success-component__disable-button",
                  onClick: (function (_event) {
                      
                    })
                }, "X"), React.createElement(RnrLoading.make, {
                  content: content
                }));
}

function getErrorView(content, onRewardToggle) {
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "reward-success-component__close-button",
                  onClick: (function (_event) {
                      return Curry._2(onRewardToggle, undefined, undefined);
                    })
                }, "X"), React.createElement(RnrISE.make, {
                  content: content
                }));
}

function RnrClaimedRewardModal(Props) {
  var rewards = Props.rewards;
  var content = Props.content;
  var selectedDate = Props.selectedDate;
  var selectedCategory = Props.selectedCategory;
  var onRewardToggle = Props.onRewardToggle;
  var requestState = Props.requestState;
  var tmp;
  if (requestState !== undefined) {
    if (typeof requestState === "number") {
      tmp = React.createElement("div", undefined, "Init");
    } else {
      switch (requestState.TAG | 0) {
        case /* Loading */0 :
            tmp = getLoadingView(content);
            break;
        case /* Live */1 :
            GAEvents.publishPageView("rnr/home/reward_modal/" + Belt_Option.mapWithDefault(selectedCategory, "", RewardCategory.toString), "RnR Home Reward Modal", undefined);
            tmp = getSuccessView(rewards, selectedDate, selectedCategory, content, onRewardToggle);
            break;
        case /* Error */2 :
            tmp = getErrorView(content, onRewardToggle);
            break;
        
      }
    }
  } else {
    GAEvents.publishPageView("rnr/history/reward_modal/" + Belt_Option.mapWithDefault(selectedCategory, "", RewardCategory.toString), "RnR History Reward Modal", undefined);
    tmp = getSuccessView(rewards, selectedDate, selectedCategory, content, onRewardToggle);
  }
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  return Curry._2(onRewardToggle, undefined, undefined);
                }),
              overlayClassName: "reward-success-modal__overlay",
              className: "reward-success-modal__content",
              shouldCloseOnOverlayClick: false,
              children: React.createElement("div", {
                    className: "reward-success-component"
                  }, tmp)
            });
}

var make = RnrClaimedRewardModal;

export {
  customerServiceLogo ,
  loginHoursLogo ,
  orderFulfillmentLogo ,
  getRewardVM ,
  getLoginActivityRewardMessage ,
  getOrderFulfillmentRewardMessage ,
  getCustomerServiceRewardMessage ,
  getCustomerServiceSuccessView ,
  getLoginActivitySuccessView ,
  getOrderFulfillmentSuccessView ,
  getSuccessView ,
  getLoadingView ,
  getErrorView ,
  make ,
  
}
/* customerServiceLogo Not a pure module */
